module.exports = __webpack_public_path__ + "static/media/user-guide-4.b4d70561.png";